import { motion } from 'framer-motion';

interface VoiceWaveformProps {
  isPlaying?: boolean;
  bars?: number;
}

const VoiceWaveform = ({ isPlaying = false, bars = 40 }: VoiceWaveformProps) => {
  return (
    <div className="flex items-center justify-center gap-1 h-20">
      {Array.from({ length: bars }).map((_, i) => (
        <motion.div
          key={i}
          className="w-1 rounded-full gradient-brand"
          style={{
            boxShadow: isPlaying ? '0 0 10px hsl(var(--gradient-cyan) / 0.5)' : 'none'
          }}
          initial={{ height: '20%' }}
          animate={
            isPlaying
              ? {
                  height: ['20%', `${Math.random() * 80 + 20}%`, '20%'],
                }
              : { height: '20%' }
          }
          transition={{
            duration: 0.5 + Math.random() * 0.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: i * 0.05,
          }}
        />
      ))}
    </div>
  );
};

export default VoiceWaveform;
